window.$ = window.jQuery = require('jquery');

require("jquery-ui/ui/widgets/datepicker");
require("jquery-ui/ui/i18n/datepicker-ja");
require("jquery-ui/ui/widgets/sortable");
// require("jquery.tocify/src/javascripts/jquery.tocify");
require("jquery.cookie/jquery.cookie");
require("magnific-popup");

require("./jquery.calendario/jquery.calendario.js");
require("./jquery.calendario/jquery.calendario-custom.js");
window.codropsEvents = require("./jquery.calendario/data.js");
